export const sidebarLocale = {
  en: {
    title: 'Integration',
    dataNotFound: 'Data not found',
    description: 'Description',
    automatic: 'Automatic',
    manual: 'Manual',
    details: 'Details',
    file: 'File',
    started: 'Started',
    completed: 'Completed',
    run: 'Run',
    retry: 'Retry',
    template: 'Template',
    inProgress: 'In progress',
    error: 'Error',
    notStarted: 'Not started',
    requestData: 'Request data',
    responseData: 'Response data',
    errorResponse: 'Error response',
    addMore: 'Add more',
    requestHeaders: 'Request Headers',
    integrationError: "Couldn't load this integration. Try again in a moment.",
    advanced: 'Advanced',
    continueOnError: 'Continue on error',
    actionDetails: 'Action details',
    triggerMethod: 'Trigger method',
    requestValues: 'Request values',
    requests: 'Requests',
    statusCode: 'Status code',
    integrationDeleted:
      'This integration has been deleted. Showing the data recorded when the action ran. To run it again, replace the action in the journey builder.',
    integrationDeletedNotRun:
      "This integration has been deleted, so this action can't run. Replace it in the journey builder.",
    fileUnavailable: 'No longer available',
  },
};
